import { render, staticRenderFns } from "./SearchEdit.vue?vue&type=template&id=4f84b284"
import script from "./SearchEdit.vue?vue&type=script&lang=js"
export * from "./SearchEdit.vue?vue&type=script&lang=js"
import style0 from "./SearchEdit.vue?vue&type=style&index=0&id=4f84b284&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports